import React from "react"
import { compose, withProps } from "recompact"
import { Field } from "redux-form"
import entityApi from "src/hocs/entity"
import resourceModel from "src/models/resource"
import Input from "src/components/Input"
import Fieldset from "@infotech/uikit-fieldset"
import { reduxForm } from "src/engine/modules/entity/plugins"
import withQueryParams from "src/hocs/withQueryParams"
import withSideModalPending from "src/hocs/withSideModalPending"
import get from "lodash/get"
import { Box } from "@infotech/uikit-grid"
import allResourceTypes from "src/hocs/allResourceTypes"
import ExternalLink from "src/components/ExternalLink"
import Select from "src/components/Selects/Select"
import customFields from "./hocs/customFields"

export const FORM_NAME = `createResourceType`

export const ResourceTypesField = allResourceTypes()(
  ({ resourceTypes: { data, pending }, isDisabled }) => (
    <div data-testid="resource-resourceTypes">
      <Field
        name="resourceTypeId"
        component={Select}
        props={{
          options: data.map(one => ({
            value: one.id,
            label: one.name,
          })),
          placeholder: `Выберите тип ресурса`,
          isLoading: pending,
          disabled: pending || isDisabled,
          clearable: true,
        }}
      />
    </div>
  ),
)

const enhancer = compose(
  withQueryParams(),
  withProps(({ match, disableEdit }) => {
    const isNew = match.params.id === `new`
    return {
      isDisabled: disableEdit && !isNew,
    }
  }),
  entityApi({
    to: `resource`,
    model: resourceModel,
    plugins: [
      /* Support redux form, all linking logic between entity module and redux
       * form has stashed in this plugin */
      reduxForm(
        withProps(({ workspace: { emit } }) => ({
          form: FORM_NAME,
          onSubmit(
            data,
            dispatch,
            {
              resource: {
                api: { save },
              },
            },
          ) {
            emit(`save`)
            return save(data)
          },
        })),
      ),
    ],
  }),
  customFields(FORM_NAME),
  withSideModalPending(`resource`, `Ресурс не найден`),
)

export default enhancer(({ CustomFields, isDisabled, resource }) => {
  const resourceExternalLink = get(resource, `data.externalLink`)
  return (
    <Box loose pl="2md" pr="2md" pt="2md">
      <Fieldset caption="Наименование ресурса*">
        <Field
          component={Input}
          name="name"
          props={{
            disabled: isDisabled,
            placeholder: `Введите наименование ресурса`,
          }}
        />
      </Fieldset>
      <Fieldset caption="Тип ресурса*">
        <ResourceTypesField isDisabled={isDisabled} />
      </Fieldset>
      {resourceExternalLink && (
        <Box loose pb="2md">
          <ExternalLink data={resourceExternalLink} />
        </Box>
      )}
      <CustomFields isDisabled={isDisabled} />
    </Box>
  )
})
